import { Button } from '@dev-spendesk/grapes';
import cx from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

import { AnalyticEventName, track } from 'src/core/utils/analytics';

type Props = {
  ctaText: string;
  ctaLink?: string;
  onCtaClick?: () => void;
  formatedAmount: string;
  formatedAmountDescription: string;
  hasWarning: boolean;
};

export const HomepageWalletDetailPrimaryAmount = ({
  ctaText,
  ctaLink,
  onCtaClick,
  formatedAmount,
  formatedAmountDescription,
  hasWarning,
}: Props) => {
  const handleClick = () => {
    track(AnalyticEventName.HOMEPAGE_WALLET_DETAILS_BUTTON_CLICKED);
    onCtaClick?.();
  };

  const renderCta = () => {
    const button = (
      <Button
        text={ctaText}
        variant={hasWarning ? 'secondaryWarning' : 'secondaryNeutral'}
        onClick={onCtaClick ? handleClick : undefined}
      />
    );

    if (ctaLink && !onCtaClick) {
      return (
        <Link to={ctaLink} onClick={handleClick}>
          {button}
        </Link>
      );
    }

    return button;
  };

  return (
    <div className="rounded-4 flex flex-col gap-20">
      <div className="flex flex-col content-stretch gap-8">
        <h2
          className={cx(
            'title-xxl',
            hasWarning
              ? 'text-content-warning-default'
              : 'text-content-primary',
          )}
        >
          {formatedAmount}
        </h2>
        <p className="text-content-secondary-bg-secondary body-m">
          {formatedAmountDescription}
        </p>
      </div>
      {renderCta()}
    </div>
  );
};
